<template lang="pug">
  form.b-password-reset-form(@submit.prevent="submit")
    h1.auth-form-title Создание нового пароля
    p._error.auth-form-error(v-if="error") {{ error }}
    template(v-if="passwordIsChanged")
      p.auth-form-desc Пароль успешно изменен
      Btn(:to="{ name: 'auth-login' }") Войти
    template(v-if="!passwordIsChanged")
      CommonInput._input(
        v-for="(field, name) in fields"
        v-model="field.value"
        v-bind="field"
        :key="name"
        @change="inputChanged(name);"
        fullwidthOn768
        )
      Btn(submit green) Сменить пароль
</template>

<script>
import CommonInput from '@/components/CommonInput.vue';

import form from '@/utils/form';
import api from '@/api/auth';

export default {
  name: 'AuthPasswordResetFrom',
  components: { CommonInput },
  data() {
    return {
      error: '',
      passwordIsChanged: false,
      /* eslint-disable */
      fields: {
        newPassword:    form.createFieldObject('password',  'Новый пароль',     '', { required: 'Укажите пароль'   } ),
        repeatPassword: form.createFieldObject('password',  'Повторите пароль', '', { required: 'Повторите пароль' } ),
      },
      /* eslint-enable */
    };
  },
  methods: {
    inputChanged(fieldName) {
      form.validateField(this.fields, fieldName);
    },
    submit() {
      form.validate(this.fields);

      const formHasErrors = form.hasErrors(this.fields);
      const passwordsAreNotEqual = this.fields.newPassword.value !== this.fields.repeatPassword.value;

      if (passwordsAreNotEqual) {
        this.fields.repeatPassword.error = 'Пароли не совпадают';
      }

      if (passwordsAreNotEqual || formHasErrors) {
        return;
      }

      const userId = document.location.search
        ?.replace('?', '')
        ?.split('&')
        ?.find((parameter) => parameter.includes('id'))
        ?.split('=')[1];

      const formData = {
        verifyingUrl: document.location.href.replace(':8080', ':8097'),
        password: this.fields.newPassword.value,
        id: userId,
      };

      api.resetPassword(formData)
        .then(() => { this.passwordIsChanged = true; })
        .catch(() => { this.error = 'Ссылка для восстановления пароля \r\nнедействительна. Попробуйте заново \r\nили обратитесь в службу поддержки.'; });
    },
  },
};
</script>

<style scoped lang="scss">
.password-reset-form {
  &__input {
    margin-bottom: 16px;
  }

  &__error {
    white-space:pre
  }

  &__btn {
    margin-bottom: 33px;
  }
}
</style>
